<template>
  <div :class="`${className}`">
    <input
      :id="id"
      type="checkbox"
      class="form-check-input me-1"
      :disabled="disabled"
    />
    <label class="form-check-label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    variant: {
      type: String,
      default: "small",
    },
    label: {
      type: String,
      default: "checkbox",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      className: "form-check-inline",
      variants: {
        small: "form-check-inline",
        large: "form-check-inline check-l",
        circle: "form-check check-circle",
      },
      id: this.randomString(),
    };
  },
  created() {
    this.className = this.variants.hasOwnProperty(this.variant)
      ? this.variants[this.variant]
      : "";
  },
};
</script>
